import { Link } from "react-router-dom";
import Wordmark from "../Brand/Wordmark";
import LoopWatermark from "../Brand/LoopWatermark";
import { CONTACT, NAV_LINKS } from "./nav";
import "./layout.css";

// TODO: replace with the real profile URLs.
const SOCIALS = [
  { label: "LinkedIn", href: "#" },
  { label: "Facebook", href: "#" },
  { label: "Instagram", href: "#" },
];

const SiteFooter = () => (
  <footer className="is-footer">
    <LoopWatermark distance={80} style={{ top: "auto", bottom: "-30%" }} />
    <div className="is-container is-footer__grid">
      <div className="is-footer__brand">
        <Wordmark tone="dark" />
        <p className="is-footer__blurb">
          A software studio in Kitchener, Ontario. Strategy, design, engineering
          and growth — one team, one stack.
        </p>
        <div className="is-footer__socials">
          {SOCIALS.map((s) => (
            <a key={s.label} href={s.href} target="_blank" rel="noreferrer">
              {s.label} ↗
            </a>
          ))}
        </div>
      </div>

      <nav aria-label="Footer" className="is-footer__col">
        <span className="is-footer__heading">Company</span>
        {NAV_LINKS.filter((l) => l.to !== "/").map((l) => (
          <Link key={l.to} to={l.to}>
            {l.label}
          </Link>
        ))}
        <Link to="/contact">Contact</Link>
      </nav>

      <div className="is-footer__col">
        <span className="is-footer__heading">Contact</span>
        <a href={CONTACT.phoneHref}>{CONTACT.phoneDisplay}</a>
        <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
        <span>{CONTACT.location}</span>
      </div>
    </div>

    <div className="is-container is-footer__legal">
      <span>© {new Date().getFullYear()} Infinitude Stack Inc. All rights reserved.</span>
    </div>
  </footer>
);

export default SiteFooter;
